import { render, staticRenderFns } from "./IrrigationRecord.vue?vue&type=template&id=db0df978&scoped=true&"
import script from "./IrrigationRecord.vue?vue&type=script&lang=ts&"
export * from "./IrrigationRecord.vue?vue&type=script&lang=ts&"
import style0 from "./IrrigationRecord.vue?vue&type=style&index=0&id=db0df978&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0df978",
  null
  
)

export default component.exports